import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'pipeSafeURL',
    standalone: false
})
export class SafeURLPipe implements PipeTransform {

    constructor(
        private sanitized: DomSanitizer,
    ) { }

    public transform(value: string): SafeHtml {
        return this.sanitized.bypassSecurityTrustResourceUrl(value);
    }
}
